import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import $ from 'jquery';
import Header from "./Header.js";
import "../App.css"
import { Link, redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCreditCard,faEnvelope,faPhone,faBuilding,faFlag,faDollar } from '@fortawesome/free-solid-svg-icons'
// import Button from "react-bootstrap/esm/Button.js";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {formatDate, parseResponseJSON,dateDifference, getDataSorted, formatDateText} from "./CommonFunctions";
import InputGroup from 'react-bootstrap/InputGroup';
import {Row,Col} from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import CommonComponents from "./CommonComponents.js";
import { Rate , Divider, Badge, Dropdown} from "rsuite";
import { Table } from 'react-bootstrap'
import { AddRepair } from "./AddRepair.js";
import PageIcon from '@rsuite/icons/Page';
import NewPost from "./AddImage.js"
import { Box, Checkbox } from "@mui/material";
import { DataGrid, gridClasses, GridToolbar, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  AppBar,
  Toolbar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const Repairs=()=>{
    const [description,setDescription]=useState("");
    const [assignedto,setAssignedto]=useState("");
    let [repairStatus,setRepairStatus]=useState("Yet to be assigned");
  const [scheduledDate,setScheduledDate]=useState("");
    let [active,setActive]=useState("");
    const [completedDate,setCompletedDate]=useState(null)
    const [roomNumber,setRoomNumber]=useState("");
    const [repairs, setRepairs] = useState([]);
    const [isAddRepair,setIsAddRepair]=useState(false);
    const [isImageUpload,setIsImageUpload] = useState(false);
    const [repairId,setRepairId]=useState("");
    const [responseForRepair,setResponseForRepair]=useState("");
    const [showDeleteRepairPopup, setShowDeleteRepairPopup]=useState(false);
    const [repairStatusFilter, setRepairStatusFilter] =useState("Incomplete")

    const [managerRatingOnRepair, setManagerRatingOnRepair] = useState("");
    const [managerComments,setManagerComments]=useState("");//update in UI and database
    const [allRooms,setAllRooms]=useState([]);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortType, setSortType] = useState("asc");
    const [loading, setLoading] = useState(false);
    const {displayNotificationMessage}=useContext(CommonComponents);
    const {roomId} = useParams();
    const [list,setList] = useState([]);
    const [showPrintSelectedRows,setShowPrintSelectedRows] = useState(false)
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      if(roomId){
        getRepairsByRoomId(roomId);
      }
      else{
      // getRepairs();
      searchRepairByStatus("Incomplete");
      
      }
      getAllRooms();
    }, []);
    // useEffect(() => {
    //   if(roomId){
    //     getRepairsByRoomId(roomId);
    //   }
    //   else{
    //   // getRepairs();
    //   searchRepairByStatus("Incomplete")
    //   }
    //   getAllRooms();
    // }, [roomId]);
   const getAllRooms=async()=>{
    try{
      await axios.get(`${url}/rooms`).then((responseForAllRooms)=>{
        console.log(responseForAllRooms.data);
        setAllRooms(responseForAllRooms.data);
      })

    }
    catch(error){
      console.log(error);
    }
   }
   const getRepairsByRoomId = async(roomId)=>{
    try{
      await axios.get(`${url}/repairs/getRepairsByRoomId/${roomId}`).then((responeForGettingRepairsByroomId)=>{
        console.log(responeForGettingRepairsByroomId.data);
        setRepairs(responeForGettingRepairsByroomId.data)
      })

    }
    catch(error){
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
   }
    const getRepairs = async () => {
      try{
      await axios.get(`${url}/repairs`).then((responseForGettingRepairs)=>{
        setRepairs(responseForGettingRepairs.data);
        console.log(responseForGettingRepairs.data)
      });
     
      }
      catch(error){
        console.log(error);
        displayNotificationMessage("error",error.response.data);
      }
    };

    // Display pop up
    const handleShowAddRepair=(repairId)=>{
      
      
      // This is when you edit a ticket
      if(repairId){
        setRepairId(repairId);
        getRepairById(repairId); // get details of ticket

      }
      else{
        // Create a ticket, before that clean the slate
        setRoomNumber("");
        setDescription("");
        setActive("");
        setAssignedto("");
        setScheduledDate(null);
        setCompletedDate(null);
        setRepairId("");
        setRepairStatus("");
        setResponseForRepair("");
        setManagerRatingOnRepair(0);
      }
      setIsAddRepair(true);
    }
    const handleAddImage = (repairId) =>{
      setIsImageUpload(true);
      if(repairId){
        setRepairId(repairId)
      }
    }

    const handleCloseAddImage = () =>{
      setIsImageUpload(false);
      // if(repairId){
      //   setRepairId(repairId)
      // }
    }  


    const handleCloseAddRepair=()=>{
      setIsAddRepair(false);
      setRepairId("")
      setResponseForRepair("");
      setManagerRatingOnRepair(0)
    }

    const handleCloseDeleteRepairPopup=()=>{
      setRepairId("")
      setShowDeleteRepairPopup(false);
      setResponseForRepair("")
    }
    const handleShowDeleteRepairPopup=(repairId)=>{
      setRepairId(repairId)
      setShowDeleteRepairPopup(true)
    }

    const deleteRepair=async(e)=>{
      if(e) e.preventDefault()
      try {

        await axios.delete(`${url}/repairs/${repairId}`).then((responseForeDeletingRepair)=>{
          // setResponseForRepair("Deleted")
          displayNotificationMessage("warning","Deleted Repair Ticket Succesfuly");
          handleCloseDeleteRepairPopup()

        });
        getRepairs();
      } catch (error) {
        console.log(error);
        displayNotificationMessage("error",error.response.data);
        
      }
    }
    const editRepairDetails=async(e,repairId)=>{
      if(e) e.preventDefault();
      try{
        var status=repairStatus;
        var roomid=roomNumber;
        // var managerRatingonRepair= managerRatingonRepair==0 ? null : managerRatingonRepair;
        setRepairId(repairId)
        await axios.patch(`${url}/repairs/${repairId}`,{
          roomid,
        description,
        status,
        scheduledDate,
        completedDate,
        active,
        assignedto,
        managerRatingOnRepair,
        managerComments
        }).then((responseForEditRepair)=>{
          console.log( "Repair updated (" + repairId +" ). Status - " + responseForEditRepair.status);
          getRepairs();
          setResponseForRepair("Updated "+ repairId);
          displayNotificationMessage("success","Updated - Ticket Number: " + repairId);
          handleCloseAddRepair();
        })


      }
      catch(error){
        console.log(error);
        displayNotificationMessage("error",error.response.data); 

      }
    }
    const saveRepairDetails=async(e)=>{
      if(e) e.preventDefault();
      try{
        var status=repairStatus;
        var roomid=roomNumber;
        var completedDate=completedDate ? completedDate : null
        var scheduledDate=scheduledDate ? scheduledDate : null
        var managerRatingOnRepair= managerRatingOnRepair==0 ? null : managerRatingOnRepair
        await axios.post(`${url}/repairs` ,{
        roomid,
        description,
        status,
        scheduledDate,
        completedDate,
        active,
        assignedto,
        managerRatingOnRepair,
        managerComments
      }).then((responseForSavingNewRepair)=>{
        const tempDbResponse=parseResponseJSON(responseForSavingNewRepair.data);
        if(tempDbResponse)
        {
          setRepairId(tempDbResponse.ticketId)
          // getRepairById(tempDbResponse.ticketId)
          setResponseForRepair("Ticket " + tempDbResponse.ticketId + " created ");
          getRepairs();
          displayNotificationMessage("success","Created a new Repair Ticket - Ticket Number: " + tempDbResponse.ticketId);
          handleCloseAddRepair();
        }

      })
      
      }
      catch(error){
        console.log(error);
        displayNotificationMessage("error",error.response.data);
      }
    }
    const getRepairById=async(repairId)=>{
      try{
      let responseForRepairById = await axios.get(`${url}/repairs/${repairId}`);
      const tempResponseForRepairId=parseResponseJSON(responseForRepairById.data);
      console.log(tempResponseForRepairId[0].managerRatingOnRepair) ;
      setRoomNumber(tempResponseForRepairId[0].roomid);
      setDescription(tempResponseForRepairId[0].description);
      setActive(tempResponseForRepairId[0].active);
      setAssignedto(tempResponseForRepairId[0].assignedto);
      setScheduledDate(tempResponseForRepairId[0].scheduledDate);
      setCompletedDate(tempResponseForRepairId[0].completedDate);
      setRepairStatus(tempResponseForRepairId[0].status);
      setManagerRatingOnRepair(tempResponseForRepairId[0].managerRatingOnRepair)
    }
    catch(error)
    {
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
  }
  const searchRepairByStatus=async(targetValue)=>{
    try{
      if(targetValue=="all")
      getRepairs();
      else{
        await axios.post(`${url}/repairs/searchRepairByStatus`,{
          targetValue
        }).then((responseForSearchingRepairByStatus)=>{
          console.log(responseForSearchingRepairByStatus.data)
          setRepairs(responseForSearchingRepairByStatus.data)
        })
      }
      


    }catch(error){
      console.log(error);
      displayNotificationMessage("error",error.response.data);
    }
  }

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };
  function handleCheckBoxList(row) {
    if (list.some((item) => item.id === row.id)) {
      // Remove the row if it already exists
      const updatedList = list.filter((item) => item.id !== row.id);
      setList(updatedList);
    } else {
      // Add the row to the list
      setList((prevList) => [...prevList, row]);
    }
  }
  const columns =[
    { field: ``, headerName: '', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <Checkbox 
          checked={list.some((item) => item.id === currentRow.id)}
          onChange={() => {
            handleCheckBoxList(currentRow);
            console.log(list); 
          }}></Checkbox>
    } },
    { field: `id`, headerName: 'Ticket No.', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <Link onClick={(e)=>handleShowAddRepair(currentRow.id)}>{currentRow.id}</Link>
    } },
    { field: `roomid`, headerName: 'Room No.', width: 80, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
            return <>{currentRow.roomid}</>
    } },
    { field: 'description', headerName: 'Description', width: 250, align: 'left',
      renderCell: (params) => {
        return <div style={{ lineHeight: "1.5em",whiteSpace: 'normal', wordBreak: 'break-all',overflowWrap: "anywhere",
          display: "block" }}>
          {params.row.description}
        </div>
      },
     },
     { field: `priority`, headerName: 'Priority', width: 80, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
          return <>{currentRow.priority}</>
  } },
    { field: 'scheduledDate', headerName: 'Scheduled at', width: 150, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
          return currentRow.scheduledDate ? formatDateText(currentRow.scheduledDate) : null;       
              
    } },
    { field: 'assignedto', headerName: 'Assigned to', width: 150, align: 'left' },

    { field: 'status', headerName: 'Status', width: 150, align: 'left' },

    { field: 'createdAt', headerName: 'Created at', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return currentRow.createdAt ? formatDateText(formatDate(currentRow.createdAt)) : null;       
            
     } },
     { field: 'daysOpen', headerName: 'Days Open', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return dateDifference(currentRow.createdAt,currentRow.completedDate ? currentRow.completedDate : new Date());       
            
     } },
     
    { field: 'completedDate', headerName: 'Completed at', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return currentRow.completedDate ? formatDateText(currentRow.completedDate) : null;       
            
    } },

    { field: 'managerComments', headerName: 'Manager Comments', width: 200, align: 'left' },
    { field: 'managerRatingOnRepair', headerName: 'Rating', width: 150, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return <Rate size="xs" style={{width:"100px"}} 
        value={currentRow.managerRatingOnRepair} readOnly></Rate>        
    } },
    { field: 'actions', headerName: 'Actions', width: 100, align: 'left' ,
      renderCell:(params)=>{
        const currentRow=params.row;
        return <>
        <Link
              onMouseMove={(e)=>handleCloseAddRepair()}
              onTouchMove={(e)=>handleCloseAddRepair()}
                onClick={()=>handleShowAddRepair(currentRow.id)}
              >
                Edit
              </Link>
              <br></br>
              {/* <Divider style={{backgroundColor:"grey",margin:"0.5rem 0rem"}}/> */}
              <Link
                onClick={()=>handleShowDeleteRepairPopup(currentRow.id)}
              >
                Delete
              </Link>
              <br></br>
              {/* <Divider  style={{backgroundColor:"grey",margin:"0.5rem 0rem"}}/> */}
              <Badge content={currentRow.imageCount ? currentRow.imageCount : 0} size="0.5rem" >  
              <Link 
              // onMouseMove={(e)=>setIsImageUpload(false)}
              // onTouchMove={(e)=>setIsImageUpload(false)}
              onClick={()=>handleAddImage(currentRow.id)}
              >Images </Link>
              </Badge>
              
              <br></br>

        </>
    } },

  ];
  function handleClosePrintSelecetdRows(){
    setShowPrintSelectedRows(false);
  }
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        
      </GridToolbarContainer>
    );
  }

    return (
      <div>
        <Header/>
        <Dropdown title={"Filter by Status"} style={{marginLeft:"5%",marginBottom:"1rem",marginTop:"1rem"}} onSelect={(e)=>{setRepairStatusFilter();searchRepairByStatus(e)}}>
            <Dropdown.Item eventKey={"all"}>All</Dropdown.Item>
            <Dropdown.Item eventKey={"Incomplete"} >Incomplete</Dropdown.Item>
            <Dropdown.Item eventKey={"Completed"}>Completed</Dropdown.Item>
            <Dropdown.Item eventKey={"Need management action"}>Need management action</Dropdown.Item>
          </Dropdown>
        {/* <Form.Select className="mb-2 mt-2 ms-5 w-25" 
              style={{float:"left"}}
              onChange={(e)=>searchRepairByStatus(e.target.value)}>
                <option value="all">All Repairs</option>
                <option value="Incomplete">Incomplete</option>
                <option value="Completed">Completed</option>
             
                <option value="Need management action">Require Management Response</option>
                
                
        </Form.Select> */}
        

        {/* <Form.Select className="mb-2 mt-2 ms-5 w-25" 
              style={{float:"left"}}
              onChange={(e)=>searchRepairByStatus(e.target.value)}>
                <option value="all">Any Time</option>
                <option value="Created last 7 days">Created Last 7 days</option>
                <option value="Created last 30 days">Created Last 30 days</option>
                <option value="open more than 3 days">Open More than 3 days</option>
                <option value="open more than 7 days">Open More than 7 days</option>
                <option value="open more than 30 days">Open More than 30 days</option>
                
        </Form.Select> */}

        <Dropdown title="Filter by Room Number" style={{marginLeft:"5%",maxHeight:"200px !important"}}>
        {allRooms.map((row, index) => (
            <Dropdown.Item eventKey={row.id}>
              {/* <Link to={`/repairs/${row.id}`}> */}
              {row.id} 
              {/* </Link> */}
              </Dropdown.Item>
        ))}
          </Dropdown>



        <Form.Label className="mt-3 ms-5" style={{fontSize:"16px"}}>Count: <b>{repairs ? repairs.length : null}</b></Form.Label>
        <Form.Label className="mt-3 ms-5" style={{fontSize:"16px"}}></Form.Label><Form.Label className="mt-3 ms-5" style={{fontSize:"16px"}}></Form.Label>
        <Form.Label className="mt-3 ms-5" style={{fontSize:"16px"}}>Selected <b>{list.length}</b> tickets</Form.Label>

        <Button className="mt-2 mb-2 me-5 ms-5"  onClick={()=>{
          console.log(list.sort(function(a, b){return a.roomid - b.roomid}))
          setShowPrintSelectedRows(true)
        }} >Print selected tickets</Button>
        
        <Button className="mt-2 mb-2 me-5" onMouseMove={(e)=>handleCloseAddRepair()} onClick={()=>handleShowAddRepair(null)} >Add A Repair</Button>

        {isAddRepair  && <AddRepair 
        value={{repairId: repairId}} repairs={repairs} setRepairs={setRepairs}
        getRepairs={getRepairs} handleCloseAddRepair={handleCloseAddRepair}/>}
        {isImageUpload && (
          <NewPost
            showDialog={isImageUpload}
            setShowDialog={setIsImageUpload}
            repairId={repairId}
          />
        )}
        

      <Box
        sx={{
          height: 550,
          width: '100%',
          '& .actions': {
            color: 'text.secondary',
          },
          '& .textPrimary': {
            color: 'text.primary',
          },
        }}
      >
        <DataGrid rows={repairs} columns={columns} getRowHeight={() => 'auto'} 
        getRowId={(row) => row.id} 
        slots={{
          toolbar: CustomToolbar,
        }}
        sx={{
          [`& .${gridClasses.cell}`]: {
            py: 1.5,
          },
        }}
        />
        
      </Box>  


      

        <Modal show={showDeleteRepairPopup} onHide={handleCloseDeleteRepairPopup}>
          <Modal.Header style={{fontSize:"large"}} closeButton>
          {responseForRepair ? responseForRepair :"Warning: Are you sure to delete this Repair?"}</Modal.Header>
          <Modal.Footer>
            <Button onClick={handleCloseDeleteRepairPopup}>No</Button>
            <Button onClick={(e)=>deleteRepair(e)}>Yes</Button>

          </Modal.Footer>
        </Modal>

{/* for printing */}
      <Dialog
        fullScreen
        open={showPrintSelectedRows}
        onClose={handleClosePrintSelecetdRows}
        aria-labelledby="full-dialog-title"
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClosePrintSelecetdRows}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Selected Tickets Details
            </Typography>
            <Button autoFocus color="inherit" onClick={(e)=>{
               window.print();
              // handleClosePrintSelecetdRows()
            }}>
              Print
            </Button>
          </Toolbar>
        </AppBar>
        <br></br><br></br>
        <DialogContent>
          <TableComponent rows={list} />
        </DialogContent>
        {/* <DialogActions>
          <Button variant="contained" color="secondary" onClick={handleClosePrintSelecetdRows}>
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
        
    );


}
const TableComponent = ({ rows }) => {
  return (

    <Table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid black"}}>
      <thead  style={{padding:"1.4rem"}}>
        <tr>
          <th>Ticket No.</th>
          <th>Room No.</th>
          <th>Description</th>
          <th>Priority</th>
          <th>Scheduled at</th>
          <th>Assigned to</th>
          {/* <th>Status</th> */}
          {/* <th>Created at</th> */}
          <th>Days Open</th>
          <th>Completed at</th>
        </tr>
      </thead>
      <tbody >
        {rows.map((row, index) => (
          <tr key={index} style={{ borderBottom: "1px solid black" }}>
            <td>{row.id}</td>
            <td style={{fontSize:"1.4rem"}}><b>{row.roomid}</b></td>
            <td style={{fontSize:"1.4rem" }}>{row.description}</td>
            <td>{row.priority}</td>
            <td>{row.scheduledDate ? formatDateText(row.scheduledDate) : ''}</td>
            <td>{row.assignedto}</td>
            {/* <td>{row.status}</td> */}
            {/* <td>{formatDateText(formatDate(row.createdAt))}</td> */}
            <td>{dateDifference(row.createdAt,row.completedDate ? row.completedDate : new Date())}</td>
            <td>{row.completedDate ? formatDateText(row.completedDate) : ''}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

const colors = {
  orange: "#FFBA5A",
  grey: "#a9a9a9"
  
};